/**
 * Check if two arrays have the same number of items and that both array contains the same string items.
 * The ordering of the items is not important.
 * @param array1 The first array to compare
 * @param array2 The second array to compare
 * @returns True if the arrays are equivalents
 */
export function ArraysAreEquivalents(array1: string[], array2: string[]): boolean {
  if (array1 === array2) {
    return true;
  }

  if (array1.length !== array2.length) {
    return false;
  }
  for (let i = 0; i < array1.length; i++) {
    if (!array2.includes(array1[i])) {
      return false;
    }
  }
  return true;
}
